// AUTO-GENERATED by scripts/generate-contracts.mjs from the .md sidecar.
// Hand edits will be overwritten on the next run. To customise this
// component's contract (add actions, structured props, custom control
// kinds, glyph pickers), remove this file's auto-generated marker and
// hand-author it — the generator skips files without the marker.

import { z } from "zod";
import { contract } from "@gradeui/contracts";

export const SheetContract = contract({
  name: "Sheet",
  description: "A panel that slides in from a screen edge — mobile nav drawers, side panels for editing a single record without leaving the list, filter trays on small viewports, Studio-style inspector panels. For a centered focus modal use Dialog. For a transient announcement use Toast (Sonner). For inline reveals use Collapsible.",
  import: "@gradeui/ui",
  aliases: ["sheet","drawer","side panel","slide-in","nav drawer","mobile drawer","slide-over","action sheet","modal sheet","bottom sheet","side sheet","react native modal sheet","bottom-sheet","ios action sheet","inspector panel","glass sheet","frosted drawer"],
  subcomponents: ["SheetTrigger","SheetContent","SheetHeader","SheetTitle","SheetDescription","SheetFooter","SheetClose"],
  composesWith: ["Form controls (an inline edit sheet)","Button (trigger + close)","AppShellNav (mobile-only swap)","Code (changelog drawers)","MediaSurface (image-detail sheets)"],
  styleDefaults: {"SheetOverlay":"fixed inset-0 z-50 bg-black/80 data-[state=open]:animate-in data-[state=closed]:animate-out data-[state=closed]:fade-out-0 data-[state=open]:fade-in-0","SheetContent":"fixed z-50 gap-4 p-6 shadow-lg transition ease-in-out data-[state=open]:animate-in data-[state=closed]:animate-out data-[state=closed]:duration-300 data-[state=open]:duration-500 inset-y-0 right-0 h-full w-3/4 border-l data-[state=closed]:slide-out-to-right data-[state=open]:slide-in-from-right sm:max-w-sm","SheetHeader":"flex flex-col space-y-2 text-center sm:text-left","SheetFooter":"flex flex-col-reverse sm:flex-row sm:justify-end sm:space-x-2","SheetTitle":"text-lg font-semibold text-foreground","SheetDescription":"text-sm text-muted-foreground"},
  props: {
  "open": {
      schema: z.unknown().optional(),
      design: "plumbing",
  },
  "defaultOpen": {
      schema: z.unknown().optional(),
      design: "plumbing",
  },
  "onOpenChange": {
      schema: z.unknown().optional(),
      design: "event",
  },
  "modal": {
      schema: z.unknown().optional(),
      design: "plumbing",
  },
  "asChild": {
      schema: z.boolean().optional(),
      design: "plumbing",
  },
  "side": {
      schema: z.enum(["top", "right", "bottom", "left"]).optional(),
      design: "knob",
      default: "right",
  },
  "surface": {
      schema: z.enum(["solid", "translucent", "glass", "glass-strong"]).optional(),
      design: "knob",
      description: "what the sheet panel is *made of*. `solid` is the default opaque `bg-background`. Reach for `glass` whenever the canvas behind the sheet (a layout in progress, a media gallery, a dashboard) should remain visible.",
  },
  "className": {
      schema: z.string().optional(),
      design: "plumbing",
      description: "usually set a width (right/left) or height (top/bottom)",
  },
  },
});
